import { render } from "./FilterOpco.vue?vue&type=template&id=d40963c2"
import script from "./FilterOpco.vue?vue&type=script&lang=js"
export * from "./FilterOpco.vue?vue&type=script&lang=js"
script.render = render

export default script